import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import '../Review.css';

export default class ReviewMapEthnicity extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMapEthnicityOpened: false
       }
    }

    getEthnicityDisplayValue = (ethnicity) => {
        let mappedEthnicity = this.props.mapOptions.filter(option => option.label === ethnicity.label);
        if (mappedEthnicity.length > 0)
            return mappedEthnicity[0].label;
        else
            return '';
    }

    render() {
        let { allEthnicityMapping } = this.props.mapEthnicity;
        let {isMapEthnicityOpened} = this.state;
        let noOfEthnicityTypesMapped = allEthnicityMapping.filter(ethnicityMapping => ethnicityMapping.column!=="").length;
        
        return (<div className="review-sub-section">
            <Row>
                <Col sm="11" md="11" className="review-sub-section-heading">Mapped {noOfEthnicityTypesMapped} of {allEthnicityMapping.length} values to ethnicity/race categories</Col>
                <Col sm="1" md="1" className={isMapEthnicityOpened ? 'rotate-arrow' : 'text-center'}>
                    <i className={(isMapEthnicityOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}
                        onClick={() => {
                            this.setState({ isMapEthnicityOpened: !isMapEthnicityOpened });
                        }} />
                </Col>
            </Row>
            <Collapse isOpen={isMapEthnicityOpened}>
                 <div className="mt30 mapped-review-records">
                   {allEthnicityMapping.map((mappedEthnicity, index) => {
                        return (<div key={index} className={'review-mapped-column '.concat(index === 0 ? ' ' : 'mt10')}>
                            <span style={{ fontWeight: '600' }}>
                            {!mappedEthnicity.value || mappedEthnicity.value===undefined||mappedEthnicity.value===null ||mappedEthnicity.value==="null"|| mappedEthnicity.value==="undefined"? 
                                mappedEthnicity.value="empty"
                                :
                                mappedEthnicity.value
                                } Ethnicity type
                            </span>
                             {mappedEthnicity.column!=="" &&mappedEthnicity.column!==null ? <span><span> mapped to </span>
                            <span style={{ fontWeight: '600' }}>{this.getEthnicityDisplayValue(mappedEthnicity.column)}</span>
                            </span>: <span> left unmapped</span>}
                        </div>
                        )
                    })}
                </div> 
            </Collapse>
        </div>
                )
    }
}
